import { AbstractControl, ValidatorFn } from '@angular/forms';

import { AuthConfig } from '@auth/auth-config';

type PasswordValidatorOption = {
  text: string;
  value: number;
  order?: number;
};

export type PasswordValidatorOptions = {
  minLength?: PasswordValidatorOption;
  minNumbers?: PasswordValidatorOption;
  minUpperCase?: PasswordValidatorOption;
  minLowerCase?: PasswordValidatorOption;
  minSpecial?: PasswordValidatorOption;
};

export type PasswordValidatorErrors = {
  minLength?: boolean;
  minNumbers?: boolean;
  minUpperCase?: boolean;
  minLowerCase?: boolean;
  minSpecial?: boolean;
};

// eslint-disable-next-line max-lines-per-function
export function PasswordValidator(options: PasswordValidatorOptions): ValidatorFn {
  // eslint-disable-next-line max-statements
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const errors: PasswordValidatorErrors = {};
    let hasErrors = false;

    if (control.value === null) {
      // If not set, return all the errors
      return {
        minLength: true,
        minLowerCase: true,
        minNumbers: true,
        minSpecial: true,
        minUpperCase: true,
      };
    }

    const numbers = control.value.match(AuthConfig.regex.numbers) || [];
    const upperCase = control.value.match(AuthConfig.regex.upperCase) || [];
    const lowerCase = control.value.match(AuthConfig.regex.lowerCase) || [];
    const special = control.value.match(AuthConfig.regex.special) || [];

    if (options.minLength && control.value.length < options.minLength.value) {
      hasErrors = true;
      errors.minLength = true;
    }

    if (options.minNumbers && numbers.length < options.minNumbers.value) {
      hasErrors = true;
      errors.minNumbers = true;
    }

    if (options.minUpperCase && upperCase.length < options.minUpperCase.value) {
      hasErrors = true;
      errors.minUpperCase = true;
    }

    if (options.minLowerCase && lowerCase.length < options.minLowerCase.value) {
      hasErrors = true;
      errors.minLowerCase = true;
    }

    if (options.minSpecial && special.length < options.minSpecial.value) {
      hasErrors = true;
      errors.minSpecial = true;
    }

    return hasErrors
      ? errors
      : null;
  };
}
